import { createNamespacedAction } from "app/pages/sales-intelligence/store/utils";

const createIndustryAction = createNamespacedAction("si/industry");

/**
 * Event dispatched when the account successfully opts into industry-taxonomy v2. Carries no reducer state —
 * it is the seam `industryOptInMiddleware` reacts to, fanning out the cross-module cache refresh and filter
 * cleanup so the industry module stays free of those dependencies.
 */
export const industryTaxonomyOptedIn = createIndustryAction<void>("taxonomy-opted-in");
